import React from 'react'
const divsArray = Array.from({ length: 5 }, index => index + 1);
const divsArray2 = Array.from({ length: 40 }, index => index + 1);

const NotificationTableSkeltonLoader = () => {
    return (
        <div className='gcn-table mt-[12px] h-[calc(100%-56px)] overflow-hidden'>
            <table>
                <thead className='!bg-white'>
                    <tr>
                        {divsArray.map(() => (
                            <th>
                                <div className='generic-skeleton w-100 m-0'></div>
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {divsArray2.map(() => (
                        <tr>
                            {divsArray.map(() => (
                                <td>
                                    <div className='generic-skeleton w-100 m-0'></div>
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    )
}

export default NotificationTableSkeltonLoader